import { Chip, TableHeaderCustomContent } from "@cdkglobal/radial";
import { useUIStateContext } from "../../../../contexts/UIStateContext";
import { CHIP_FILTER_FIELD_BY_SETUP } from "../../constants";
import { JsonSchema, PrimitiveValueType } from "../../../../types";

export default function TableHeaderContent({
  schema,
}: Readonly<{
  schema: JsonSchema;
}>): JSX.Element {
  const { chipFilterValue, setChipFilterValue } = useUIStateContext();
  const chipFilteredField =
    CHIP_FILTER_FIELD_BY_SETUP.get(schema.title) ?? undefined;

  const enumOptions = chipFilteredField
    ? schema.properties[chipFilteredField]?.enum
    : undefined;

  const toggleChip = (option: PrimitiveValueType) => {
    setChipFilterValue((prev) =>
      prev.includes(option)
        ? prev.filter((v) => v !== option)
        : [...prev, option],
    );
  };
  if (schema.title === "ReportGroupCodes" && enumOptions) {
    return (
      <TableHeaderCustomContent
        customHeaderContent={
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {enumOptions.map((option) => (
              <Chip
                key={option as string}
                label={option}
                isSelected={chipFilterValue.includes(option)}
                onClick={() => toggleChip(option)}
              />
            ))}
          </div>
        }
      />
    );
  }

  return <></>;
}
